import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Container } from 'reactstrap';
import { HeaderNavBar, SidebarMenu } from '../../../Components';
import { InternalBreadcrumb } from '../../InternalBreadcrumb';
import { useUserStore } from '../../../stores/user';
import './styles.scss';

export default function MainLayout() {
	const [isOpen, setIsOpen] = React.useState(true);
	// CWE-922: el guard usa isLogged, no el token (que ya no vive en JS con el
	// modelo cookie). Antes chequeaba `token`, que ahora es siempre undefined →
	// redirigía siempre a "/" → loop con la redirección a /courses del login.
	const isLogged = useUserStore((state) => state.isLogged);

	if (!isLogged) {
		return <Navigate to="/" replace />;
	}

	return (
		<div className={'MainLayout'}>
			<HeaderNavBar />
			<Container fluid className="MainLayout_Wrapper">
				<SidebarMenu context={{ isOpen, setIsOpen }} />
				<div
					className={`w-main ${isOpen ? 'open' : 'close'}`}
					style={{ overflowY: 'auto' }}
				>
					<InternalBreadcrumb key={'InternalBreadcrumb'} />
					<Outlet />
				</div>
			</Container>
		</div>
	);
}
